import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=3f36e554&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f36e554')) {
      api.createRecord('3f36e554', component.options)
    } else {
      api.reload('3f36e554', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=3f36e554&", function () {
      api.rerender('3f36e554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Banner.vue"
export default component.exports